export const AUCTION_MODULE_PDP = 'auctionModuleDlosPDP';
export const AUCTION_SIDERAIL_REDESIGN = 'AuctionPDPSiderail';
export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
export const SOLD_PDP_V1 = 'SoldPDPV1';
